<template>
  <v-dialog v-model="dialog" max-width="980" scrollable persistent>
    <v-card>
      <v-card-title class="primary white--text py-3">
        <div class="font-weight-bold">Detail</div>
        <v-spacer />
        <v-btn icon dark @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-5 grey lighten-4 detail-content">
        <v-card class="mb-4 profile-card" outlined>
          <v-card-text class="pa-5">
            <div class="title font-weight-bold mb-5 black--text">Detail Indikasi Kecurangan</div>
            <v-row dense>
              <v-col cols="12" :md="scoreItems.length ? 6 : 12">
                <div class="d-flex align-center mb-4">
                  <v-avatar color="primary" size="42" class="mr-3">
                    <v-icon dark>mdi-account-alert</v-icon>
                  </v-avatar>
                  <div>
                    <div class="caption text-uppercase text--disabled font-weight-bold">Info User</div>
                    <div class="subtitle-1 font-weight-bold black--text">{{ userName }}</div>
                  </div>
                </div>
                <v-simple-table dense class="transparent detail-info-table">
                  <tbody>
                    <tr>
                      <td>Nama Pengguna</td>
                      <td class="font-weight-bold text-right">{{ userName }}</td>
                    </tr>
                    <tr>
                      <td>Organisasi</td>
                      <td class="font-weight-bold text-right">{{ organisasiName }}</td>
                    </tr>
                    <tr>
                      <td>Perangkat</td>
                      <td class="font-weight-bold text-right">{{ deviceName }}</td>
                    </tr>
                    <tr>
                      <td>Waktu Presensi</td>
                      <td class="font-weight-bold text-right">{{ item.waktu_scan | toDT }}</td>
                    </tr>
                    <tr>
                      <td>Lokasi (Lat, Long)</td>
                      <td class="font-weight-bold text-right">{{ item.latitude }}, {{ item.longitude }}</td>
                    </tr>
                    <tr>
                      <td>Versi</td>
                      <td class="font-weight-bold text-right">{{ item.version_code }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>

              <v-col v-if="scoreItems.length" cols="12" md="6">
                <div class="d-flex align-center justify-space-between mb-4">
                  <div>
                    <div class="caption text-uppercase text--disabled font-weight-bold">Info Score</div>
                    <div class="subtitle-1 font-weight-bold black--text">Skor Indikasi Kecurangan</div>
                  </div>
                  <v-chip :color="fraudColors[item.fraud_level]" text-color="white">
                    {{ fraudLabels[item.fraud_level] || 'Tidak diketahui' }}
                  </v-chip>
                </div>

                <v-row dense>
                  <v-col v-for="score in scoreItems" :key="score.key" cols="12">
                    <v-card outlined flat class="summary-card">
                      <v-card-text class="pa-3 d-flex align-center">
                        <v-icon small color="warning" class="mr-2">mdi-alert-circle-outline</v-icon>
                        <div class="body-2 font-weight-medium score-label">
                          {{ score.label }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <div class="history-title d-flex align-center mb-3">
          <v-icon x-small class="mr-2" color="blue-grey lighten-1">mdi-clock-outline</v-icon>
          <span class="caption font-weight-bold text-uppercase blue-grey--text text--darken-2">
            Riwayat Presensi
          </span>
        </div>

        <v-card class="history-period-card mb-3" outlined>
          <v-card-text class="py-3 px-4">
            <div class="history-filter-wrap">
              <div class="d-flex align-start history-period-info">
                <v-icon color="primary" small class="mr-3 mt-1">mdi-calendar-clock</v-icon>
                <div>
                  <div class="body-2 blue-grey--text text--darken-3">
                    {{ riwayatPresensi.length }} aktivitas scan terdeteksi
                  </div>
                  <div class="caption text--disabled mt-1">
                    {{ filteredRiwayatPresensi.length }} riwayat ditampilkan.
                  </div>
                </div>
              </div>
              <div class="history-filter-actions">
                <v-menu
                  ref="dateMenu"
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="filterTanggal"
                      label="Pilih Tanggal"
                      prepend-icon="mdi-calendar"
                      readonly
                      clearable
                      dense
                      outlined
                      hide-details
                      class="history-date-filter"
                      v-on="on"
                      @click:clear="filterTanggal = null"
                    />
                  </template>
                  <v-date-picker v-model="filterTanggal" no-title scrollable locale="id">
                    <v-spacer></v-spacer>
                    <v-btn depressed text color="primary" @click="dateMenu = false">Cancel</v-btn>
                    <v-btn depressed text color="primary" @click="$refs.dateMenu.save(filterTanggal)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <v-data-table
          dense
          :headers="headers"
          :items="filteredRiwayatPresensi"
          :items-per-page="10"
          class="elevation-0 fraud-history-table"
        >
          <template v-slot:item.no="{ index }">
            {{ index + 1 }}
          </template>
          <template v-slot:item.waktu_scan="{ item: row }">
            {{ row.waktu_scan | toDT }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { FRAUD_COLORS, FRAUD_LABELS } from '@/modules/indikasiCurang/const'

export default {
  name: 'DetailIndikasiCurang',
  data() {
    return {
      dialog: false,
      item: {},
      headers: [
        { text: 'No', align: 'left', value: 'no', sortable: false },
        { text: 'Waktu Scan', align: 'left', value: 'waktu_scan' },
        { text: 'Nama Perangkat', align: 'left', value: 'nama_perangkat' },
      ],
      fraudColors: FRAUD_COLORS,
      fraudLabels: FRAUD_LABELS,
      filterTanggal: null,
      dateMenu: false,
    }
  },
  computed: {
    detailData() {
      return this.item && this.item.data && typeof this.item.data === 'object' ? this.item.data : {}
    },
    riwayatPresensi() {
      return Array.isArray(this.detailData.riwayat_presensi) ? this.detailData.riwayat_presensi : []
    },
    filteredRiwayatPresensi() {
      if (!this.filterTanggal) return this.riwayatPresensi
      return this.riwayatPresensi.filter((row) => String(row.waktu_scan || '').slice(0, 10) === this.filterTanggal)
    },
    scoreItems() {
      if (this.detailData && this.detailData.breakdown) {
        const breakdown = (this.detailData && this.detailData.breakdown) || {}
        return Object.keys(breakdown).map((key) => {
          return {
            key: (breakdown[key] && breakdown[key]['score']) || 0,
            label: (breakdown[key] && breakdown[key]['keterangan']) || '',
          }
        })
      }

      const score = this.detailData.score && typeof this.detailData.score === 'object' ? this.detailData.score : {}
      return Object.keys(score)
        .filter((key) => score[key] !== 0)
        .map((key) => {
          return {
            key,
            label: this.formatScoreLabel(key),
          }
        })
    },
    userName() {
      return (this.item.user && this.item.user.nama) || '-'
    },
    organisasiName() {
      return (this.item.organisasi && this.item.organisasi.nama) || '-'
    },
    deviceName() {
      return this.item.nama_perangkat || '-'
    },
  },
  methods: {
    open(item) {
      if (!item) return
      this.item = item
      this.filterTanggal = null
      this.dateMenu = false
      this.dialog = true
    },
    close() {
      this.dialog = false
    },
    formatScoreLabel(key) {
      return String(key || '')
        .replace(/[_-]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/\w\S*/g, (text) => text.charAt(0).toUpperCase() + text.slice(1).toLowerCase())
    },
  },
}
</script>

<style scoped>
.detail-content {
  max-height: 82vh;
}

.profile-card,
.history-period-card {
  border-color: #dfe5ec !important;
  border-radius: 10px !important;
}

.summary-card {
  background-color: #fafafa;
  border-color: #eef1f4 !important;
  border-radius: 8px !important;
}

.detail-info-table td:first-child {
  color: rgba(0, 0, 0, 0.58);
}

.history-title::after {
  content: '';
  display: block;
  height: 1px;
  background: #e4e9f0;
  flex: 1;
  margin-left: 10px;
}

.history-filter-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.history-period-info {
  min-width: 250px;
}

.history-filter-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}

.history-date-filter {
  width: 260px;
}

.history-date-filter ::v-deep .v-input__prepend-outer {
  margin-right: 6px;
}

.history-date-filter ::v-deep .v-input__slot {
  min-height: 38px !important;
}

.history-date-filter ::v-deep input {
  font-size: 13px;
}

.fraud-history-table {
  border: 1px solid #eef1f4;
  border-radius: 10px;
  overflow: hidden;
}

.score-label {
  word-break: break-word;
}

@media (max-width: 960px) {
  .history-filter-wrap {
    align-items: flex-start;
    flex-direction: column;
  }

  .history-filter-actions {
    justify-content: flex-start;
    width: 100%;
  }
}

@media (max-width: 600px) {
  .history-date-filter {
    width: 100%;
  }
}
</style>
